import React, { FC } from 'react'
import './AdminMobileHeader.scss'
import logo from '../../../Assets/Images/logo-white.svg'
import { Link, useNavigate } from 'react-router-dom'
import EmployeeSideBarContent from '../Sidebar/EmployeeSideBar/EmployeeSideBarContent/EmployeeSideBarContent'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { useAuth } from 'Components/AuthProvider/AuthProvider'

interface propsType {
  publicAccess?: boolean
}
const EmployeeMobileHeader: FC<propsType> = ({ publicAccess }) => {
  const navigate = useNavigate()
  const { user } = useAuth()

  const switchAdmin = () => {
    Swal.fire({
      title: 'Switch...',
      text: 'Loading admin dashboard configurations, please wait',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    setTimeout(() => {
      Swal.close()
      navigate('/admin')
    }, 4000)
  }

  const role = useSelector((state: { role: string }) => state.role)

  return (
    <header className='admin-mobile-header'>
      <div className='container h-100 px-4'>
        <div className='row h-100'>
          {!publicAccess && (
            <div className='col-2 my-auto'>
              <button
                className='btn d-flex justify-content align-item-center'
                type='button'
                data-bs-toggle='offcanvas'
                data-bs-target='#offcanvasExample'
                aria-controls='offcanvasExample'
              >
                <i className='d-icon d-menu-hamburger' aria-hidden='true'></i>
              </button>
            </div>
          )}
          <div className={!publicAccess ? 'col-5 my-auto' : 'col-12 text-center my-auto'}>
            <Link className='navbar-brand' to='/'>
              <img src={logo} className='logo mb-1' />
            </Link>
          </div>

          <div className='col-5 px-0 my-auto'>
            <ul className='nav float-end'>
              {(['admin', 'hr', 'finance', 'management', 'manager'].includes(user.role) ||
                ['admin', 'hr', 'finance', 'management', 'manager'].includes(role)) && (
                <li className='nav-item'>
                  <a className='nav-link navdate' href='#' onClick={switchAdmin}>
                    <i className='d-icon d-onboard text-white'></i>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div
          className='offcanvas offcanvas-start' 
          tabIndex={-1}
          id='offcanvasExample'
          aria-labelledby='offcanvasExampleLabel'
        >
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title text-light' id='offcanvasExampleLabel'>
              Menu
            </h5>
            <button
              type='button'
              className='btn-close bg-white text-dark'
              data-bs-dismiss='offcanvas'
              aria-label='Close'
            ></button>
          </div>
          <div className='offcanvas-body px-0'>
            <EmployeeSideBarContent></EmployeeSideBarContent>
          </div>
        </div>
      </div>
    </header>
  )
}

export default EmployeeMobileHeader